import { LucideRows2 } from "lucide-react";
import { LuSearch, LuChevronDown } from "@/Components/Icons/Icons.jsx";

export default {
    row1 : [
    {
        column: "column1",
        // columnWidth: "55%",
        rows: {
            row1: [
                {
                    name: "regtype",
                    label: "Reg Type",
                    component: "dropdown",
                    options: [
                        { label: "BIN_NO", value: "bin_NO" },
                        { label: "CIN_NO", value: "cin_NO" },
                        { label: "CST_NO", value: "cst_NO" },
                        { label: "GSTIN", value: "gstin" },
                        { label: "IE_CODE_NO", value: "ie_CODE_NO" },
                        { label: "PAN_NO", value: "pan_NO" },
                        { label: "ST_NO", value: "st_NO" },
                        { label: "ST_REG_NO", value: "st_REG_NO" },
                        { label: "TAN_NO", value: "tan_NO" },
                        { label: "VAT_NO", value: "vat_NO" },
                      ],
                },
                {
                    name: "regNumber",
                    label: "Registration Number",
                    component: "text-field",
                    required:true
                }
            ],
            row2: [
                {
                    name: "branch",
                    label: "Branch",
                    component: "dropdown",
                    width: "49%",
                },
                {
                    name: "customerAddressIsDeactivate",
                    checkboxLabel: "Unregistered",
                    component: "checkboxbox",
                    sx:{
                        mt:4
                    }
                  },

            ],
            row3: [

                {
                    name: "consigneePreferredDeliveryFCL",
                    label: "Registration Date",
                    component: "dateselector",
                    width: "50%",
                },

                {
                    name: "valitedUpTo",
                    label: "Valid Up To",
                    component: "dateselector",
                    width: "50%",

                }
            ],

        }
    },
]
}



